import { useMemo } from 'react';
import { ChatModuleType } from 'app/copied/models/ChatModules';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export function useLiveChatModuleAvailable() {
  const { data: helpCenter } = useFetchHelpCenter();
  const nnOnline = !!helpCenter?.nurses_are_online;

  const hasLiveChatModule = !!useMemo(
    () => helpCenter?.modules?.some((module) => module.module_type === ChatModuleType.LiveChat),
    [helpCenter]
  );

  return hasLiveChatModule && nnOnline;
}
